import { Promotion } from '../../promo_creation/types'
import { PromotionDisplay } from './promotion_display'

interface PromotionCardProps {
  promotion: Promotion
  onEdit: (promotion: Promotion) => void
  onDelete?: (promotionId: string) => void
}

export function PromotionCard({ promotion, onEdit, onDelete }: PromotionCardProps) {
  function handleDelete() {
    if (promotion.id && onDelete) {
      onDelete(promotion.id)
    }
  }

  return (
    <PromotionDisplay
      promotion={promotion}
      onEdit={() => onEdit(promotion)}
      onDelete={promotion.id ? handleDelete : undefined}
    />
  )
}
